import { colors } from '../theme/colors';

export const HAS_PSUDO_SKELETON = 'has-psudo-skeleton';
export const HAS_PSUDO_SKELETON_DARK = 'has-psudo-skeleton dark';
export const HAS_PSUDO_SKELETON_LIGHT = 'has-psudo-skeleton light';
export const HAS_PSUDO_SKELETON_LIGHTER = 'has-psudo-skeleton lighter';
export const PSUDO_SKELETON_WRAPPER = 'has-psudo-skeleton-wrapper';
export const PSUDO_SKELETON_WRAPPER_ACTIVE = 'has-psudo-skeleton-wrapper active';
export const PSUDO_SKELETON_NO_PADDING = 'no-padding';
export const PSUDO_SKELETON_ABSOLUTE = 'absolute';
export const PSUDO_FULL_WIDTH = 'full-width';

export const psudoSkeletonStyles = `
  .${HAS_PSUDO_SKELETON} {
    transition: opacity 0;
  }

  .${HAS_PSUDO_SKELETON} > * {
    visibility: visible;
  }

  .${HAS_PSUDO_SKELETON}::after {
    content: ' ';
    position: absolute;
    width: 100%;
    height: calc(100% - 8px);
    left: 0;
    top: 4px;
    background-color: ${colors.sandDune};
    visibility: hidden;
  }
  .${HAS_PSUDO_SKELETON}.no-padding::after {
    height: 100%;
    top: 0;
  }
  .${PSUDO_SKELETON_WRAPPER}.active .${HAS_PSUDO_SKELETON} {
    opacity: 0.4;
    width: fit-content;
    position: relative;
  }
  .${PSUDO_SKELETON_WRAPPER}.active .${HAS_PSUDO_SKELETON}.full-width {
    width: 100%;
  }
  .${PSUDO_SKELETON_WRAPPER}.active .${HAS_PSUDO_SKELETON}.absolute {
    position: absolute;
  }
  .${PSUDO_SKELETON_WRAPPER}.active .${HAS_PSUDO_SKELETON}.dark {
    opacity: 0.6;
  }
  .${PSUDO_SKELETON_WRAPPER}.active .${HAS_PSUDO_SKELETON}.light {
    opacity: 0.2;
  }
  .${PSUDO_SKELETON_WRAPPER}.active .${HAS_PSUDO_SKELETON}.lighter {
    opacity: 0.2;
  }
  .${PSUDO_SKELETON_WRAPPER}.active .${HAS_PSUDO_SKELETON}::after {
    visibility: visible;
  }
  .${PSUDO_SKELETON_WRAPPER}.active .${HAS_PSUDO_SKELETON} > * {
    visibility: hidden;
    color: transparent;
    background-color: transparent;
    opacity: 0;
  }
`;
